import { formatStreamStatus } from "./streamRagClient";
import AssistantMarkdown from "./AssistantMarkdown";

function ChatMessage({
   role,
   text,
   isError = false,
   isStreaming = false,
   streamStatus,
}) {
   const isUser = role === "user";
   const messageClassName = [
      "chat-message",
      isUser ? "chat-message-user" : "chat-message-ai",
      isError ? "chat-message-error" : "",
      isStreaming ? "chat-message-streaming" : "",
   ]
      .join(" ")
      .trim();

   const statusLabel = formatStreamStatus(streamStatus);

   return (
      <div className={messageClassName}>
         {isStreaming && !text ? (
            statusLabel ? (
               <p className="chat-stream-status" aria-live="polite">
                  {statusLabel}
               </p>
            ) : (
               <div className="typing-indicator" aria-label="Assistant is typing">
                  <span />
                  <span />
                  <span />
               </div>
            )
         ) : isUser ? (
            <p>{text}</p>
         ) : (
            <div className="chat-message-markdown-wrap">
               <AssistantMarkdown text={text} />
               {isStreaming ? (
                  <span className="chat-stream-cursor" aria-hidden="true" />
               ) : null}
            </div>
         )}
      </div>
   );
}

export default ChatMessage;
